import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { getBillingStatus } from '../../api/client';

export default function SubscribeSuccess() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('loading');
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    async function check() {
      try {
        const billing = await getBillingStatus();
        setStatus(billing.access === 'full' ? 'success' : 'pending');
      } catch {
        setStatus('pending');
      }
    }
    // Small delay to let webhook process
    setTimeout(check, 2000);
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-navy flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img src="/bcd-icon.png" alt="BCD" className="h-10 mx-auto mb-3" />
          <h1 className="text-2xl font-heading font-bold text-white uppercase tracking-wide">
            The Clarity Map
          </h1>
        </div>

        <div className="bg-white rounded-2xl shadow-xl p-8 text-center">
          {status === 'loading' ? (
            <p className="text-txt-secondary">Confirming your subscription...</p>
          ) : status === 'success' ? (
            <>
              <p className="text-xl font-heading font-bold text-txt-primary mb-2">You're all set!</p>
              <p className="text-sm text-txt-secondary mb-6">
                Your annual subscription is active.<br />Welcome to The Clarity Map.
              </p>
              <Link to="/dashboard" className="btn-gold inline-block text-sm">
                Go to Dashboard
              </Link>
            </>
          ) : (
            <>
              <p className="text-xl font-heading font-bold text-txt-primary mb-2">Payment received!</p>
              <p className="text-sm text-txt-secondary mb-6">
                Your subscription is being activated. This usually takes a few seconds.
              </p>
              <Link to="/dashboard" className="btn-gold inline-block text-sm">
                Go to Dashboard
              </Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
